import Iconized from "@/components/iconized/index";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  props: {
    title: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: "download",
    },
    href: {
      type: String,
      required: true,
    },
  },
  components: { Iconized },
  mixins: [dynamicLocalization],
};
